import { StageUsage } from '../stages';
import mockedRequester from './mockedRequester';
export const mockedStage = {
    id: 1,
    name: 'Foo',
    description: 'Bar',
    bbchIndex: '09',
    isBbch: true,
    stageUsages: [StageUsage.default],
    date: '1612874239',
    cycleId: 9
};
const mock = {
    fillDate: mockedRequester(mockedStage, 'stages.update'),
    get: mockedRequester(mockedStage, 'stages.get'),
    getAll: mockedRequester([mockedStage], 'stages.getAll')
};
export default mock;
